export default "__VITE_ASSET__jzUUvmg2__"